import { ZodSchema } from 'zod';

export interface SafeParseGrouping<T> {
    valid: T[];
    invalid: T[];
}

export const safeGroupParse = <T>(data: T[], zodMethod: () => ZodSchema<T>): SafeParseGrouping<T> =>
    data.reduce<SafeParseGrouping<T>>(
        (acc, cur) => {
            const schema = zodMethod();
            const validated = schema.safeParse(cur);

            if (validated.success) {
                acc.valid.push(cur);
            } else {
                acc.invalid.push(cur);
            }

            return acc;
        },
        { valid: [], invalid: [] }
    );
